import {
	Button,
	Form,
	Input,
	InputNumber,
	Modal,
	Popconfirm,
	Select,
	Space,
	Spin,
	Typography,
} from "antd";
import { USER_INFO } from "../../../../configs/auth";
import React, { useEffect, useState } from "react";
import { DataKitchenParam } from "../../../../apis/model/kitchen.model";
import kitchen from "../../../../apis/admin/kitchenService";
import { Link, useNavigate, useParams } from "react-router-dom";
import notificationHandler from "../../../atoms/Notification";
import {
	ArrowLeftOutlined,
	ExclamationCircleOutlined,
	LoadingOutlined,
	ReloadOutlined,
	SaveOutlined,
} from "@ant-design/icons";
import {
	handleKeyDownPreventDifferentNumber,
	handlePastePreventDifferentNumber,
} from "../../../helper";

const EditKitchen = () => {
	const { Title } = Typography;
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const { id }: any = useParams();
	const [loading, setLoading] = useState(false);
	const [modal, contextHolder] = Modal.useModal();

	const auth = JSON.parse(localStorage.getItem(USER_INFO) ?? "");
	const isSupperAdmin = auth?.roles.includes("SUPER_ADMIN");

	const confirm = (values: any) => {
		modal.confirm({
			title: "Bạn có chắc chắn muốn thay đổi dữ liệu?",
			icon: <ExclamationCircleOutlined />,
			okText: "Đồng ý",
			cancelText: "Hủy",
			okType: "danger",
			onOk: () => onFinish(values),
		});
	};

	const antIcon = (
		<LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
	);

	useEffect(() => {
		kitchen
			.getOneKitchen(id)
			.then((response: any) => {
				const data = {
					kitchenName: response.data.data.payload.kitchenName,
					kitchenAddress: response.data.data.payload.kitchenAddress,
					mealPrice: response.data.data.payload.mealPrice,
					status: response.data.data.payload.status,
					contactPhoneNumber: response.data.data.payload.contactPhoneNumber,
					contactName: response.data.data.payload.contactName,
					contactCode: response.data.data.payload.contactCode,
					email: response.data.data.payload.email,
					merchantCode: response.data.data.payload.merchantCode,
					accessCode: response.data.data.payload.accessCode,
					hashKey: response.data.data.payload.hashKey,
					timeAllowedOrder: response.data.data.payload.timeAllowedOrder,
					timeAllowedUpdate: response.data.data.payload.timeAllowedUpdate,
					timeAllowedDonate: response.data.data.payload.timeAllowedDonate,
					timeAllowedCancel: response.data.data.payload.timeAllowedCancel,
					notificationPhoneNumber: response.data.data.payload
						.notificationPhoneNumber
						? response.data.data.payload.notificationPhoneNumber.replace(
								/,/g,
								", "
						  )
						: "",
				};
				form.setFieldsValue(data);
			})
			.catch((err: any) => {
				notificationHandler("error", err.response.data.data.msg_content);
			});
	}, []);

	const onFinish = (values: any) => {
		setLoading(true);
		const data = {
			kitchenName: values.kitchenName,
			kitchenAddress: values.kitchenAddress,
			mealPrice: Number(values.mealPrice),
			status: Number(values.status),
			contactPhoneNumber: values.contactPhoneNumber,
			contactName: values.contactName,
			contactCode: values.contactCode,
			email: values.email,
			merchantCode: values.merchantCode,
			accessCode: values.accessCode,
			hashKey: values.hashKey,
			configTimeRequestDto: {
				timeAllowedOrder: values.timeAllowedOrder,
				timeAllowedUpdate: values.timeAllowedUpdate,
				timeAllowedDonate: values.timeAllowedDonate,
				timeAllowedCancel: values.timeAllowedCancel,
			},
			notificationPhoneNumber: values.notificationPhoneNumber,
		};
		kitchen
			.updateKitchen(id, data)
			.then(() => {
				notificationHandler("success", "Sửa thông tin bếp ăn thành công!");
				navigate("/admin/listKitchen");
				setLoading(false);
			})
			.catch((err) => {
				notificationHandler("error", err.response.data.data.msg_content);
				setLoading(false);
			});
	};
	const validateSpecialCharacters = (_: any, value: any) => {
		const specialCharsRegex = /[!"#$%&'()*+,\./:;<=>?@[\\\]^`{|}~]/;
		if (specialCharsRegex.test(value)) {
			return Promise.reject("Dữ liệu nhập vào không được chứa ký tự đặc biệt!");
		}
		return Promise.resolve();
	};
	const validatePhoneNumber = (_: any, value: any) => {
		if (!value) {
			return Promise.reject("Vui lòng nhập số điện thoại!");
		}
		const phoneNumberRegex = /(((\+|)84)|0)(3|5|7|8|9)+([0-9]{8})\b/;
		if (!phoneNumberRegex.test(value)) {
			return Promise.reject("Số điện thoại không hợp lệ, vui lòng thử lại!");
		}
		return Promise.resolve();
	};
	const validateEmail = (_: any, value: any) => {
		if (!value) {
			return Promise.reject("Vui lòng nhập địa chỉ email!");
		} else if (
			!/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
				value
			)
		) {
			return Promise.reject("Địa chỉ email không hợp lệ, vui lòng thử lại!");
		}
		return Promise.resolve();
	};
	return (
		<div className="p-[20px]">
			<Spin indicator={antIcon} spinning={loading} />
			<Title className="!text-[20px]">Sửa thông tin bếp ăn</Title>
			<Form
				form={form}
				name="change menu"
				labelCol={{ span: 16 }}
				wrapperCol={{ span: 16 }}
				layout={"vertical"}
				style={{ maxWidth: 1800 }}
				onFinish={confirm}
				autoComplete="off"
			>
				<div className="form-kitchen" style={{ display: "flex" }}>
					<div className="form-kitchen-left" style={{ width: "600px" }}>
						<Form.Item
							label="Tên bếp ăn"
							name="kitchenName"
							rules={[
								{ required: true, message: "Vui lòng nhập tên bếp ăn!" },
								{ validator: validateSpecialCharacters },
							]}
						>
							<Input
								placeholder="Nhập tên bếp ăn"
								showCount
								maxLength={200}
								onBlur={(e) =>
									form.setFieldValue("kitchenName", e.target.value.trim())
								}
							/>
						</Form.Item>
						<Form.Item
							label="Địa chỉ"
							name="kitchenAddress"
							rules={[
								{ required: true, message: "Vui lòng nhập địa chỉ!" },
								{ validator: validateSpecialCharacters },
							]}
						>
							<Input
								placeholder="Nhập địa chỉ"
								showCount
								maxLength={200}
								onBlur={(e) =>
									form.setFieldValue("kitchenAddress", e.target.value.trim())
								}
							/>
						</Form.Item>
						<Form.Item
							label="Giá"
							name="mealPrice"
							rules={[
								{ required: true, message: "Vui lòng nhập giá!" },
								{ validator: validateSpecialCharacters },
							]}
						>
							<InputNumber
								placeholder="Nhập giá suất ăn"
								maxLength={7}
								min={0}
								precision={2}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
								className="w-full"
							/>
						</Form.Item>
						<Form.Item
							label="Trạng Thái"
							name="status"
							rules={[{ required: true, message: "Vui lòng chọn trạng thái!" }]}
						>
							<Select
								placeholder={"Chọn trạng thái"}
								style={{ width: "100%" }}
								options={[
									{ value: 0, label: "Không hoạt động" },
									{ value: 1, label: "Hoạt động" },
								]}
							/>
						</Form.Item>
						<Form.Item
							label="Số điện thoại"
							name="contactPhoneNumber"
							rules={[
								{ required: true, message: "" },
								{
									validator: validatePhoneNumber,
								},
							]}
						>
							<Input
								placeholder="Nhập số điện thoại"
								showCount
								maxLength={13}
								onBlur={(e) =>
									form.setFieldValue(
										"contactPhoneNumber",
										e.target.value.trim()
									)
								}
							/>
						</Form.Item>
						<Form.Item
							label="Tên quản lý"
							name="contactName"
							rules={[
								{ required: true, message: "Vui lòng nhập tên quản lý!" },
								{ validator: validateSpecialCharacters },
							]}
						>
							<Input
								showCount
								placeholder="Nhập tên quản lý"
								maxLength={200}
								onBlur={(e) =>
									form.setFieldValue("contactName", e.target.value.trim())
								}
							/>
						</Form.Item>
						<Form.Item
							label="Email"
							name="email"
							rules={[
								{
									required: true,
									message: "",
								},
								{
									validator: validateEmail,
								},
							]}
						>
							<Input
								placeholder="Nhập email"
								showCount
								maxLength={200}
								onBlur={(e) =>
									form.setFieldValue("email", e.target.value.trim())
								}
							/>
						</Form.Item>
						<Form.Item
							label="Mã nhân viên"
							name="contactCode"
							rules={[
								{ required: true, message: "Vui lòng nhập mã nhân viên!" },
							]}
						>
							<Input
								placeholder="Nhập mã nhân viên"
								showCount
								maxLength={200}
								onBlur={(e) =>
									form.setFieldValue("contactCode", e.target.value.trim())
								}
							/>
						</Form.Item>
						<Form.Item>
							<div className="flex">
								<Button
									htmlType="button"
									type="primary"
									className=" mt-4 mr-4 border-[#808080] hover:border-[#808080] hover:text-[#808080] hover:bg-white bg-[#808080] text-white"
								>
									<Link to={"/admin/listKitchen"} className="flex items-center">
										<ArrowLeftOutlined className="mr-2" /> Quay lại
									</Link>
								</Button>
								<Button
									htmlType="submit"
									type="primary"
									className="mt-4 bg-[#1890ff] hover:bg-white hover:text-[#1890ff]"
									loading={loading}
								>
									<SaveOutlined /> Cập nhật
								</Button>
								<Button
									htmlType="reset"
									className="mt-4 text-[##ff4d4f] ml-4  bg-[#ff4d4f] text-white"
									danger
								>
									<ReloadOutlined /> Đặt lại
								</Button>
							</div>
						</Form.Item>
					</div>
					<div className="form-kitchen-right" style={{ width: "600px" }}>
						<Form.Item
							label="Merchant Code"
							name="merchantCode"
							rules={[
								{
									required: true,
									message: "Vui lòng nhập thông tin merchant code!",
								},
							]}
						>
							<Input
								placeholder="Nhập merchant code"
								showCount
								disabled={!isSupperAdmin}
								maxLength={200}
								onBlur={(e) =>
									form.setFieldValue("merchantCode", e.target.value.trim())
								}
							/>
						</Form.Item>
						<Form.Item
							label="Access code"
							name="accessCode"
							rules={[
								{
									required: true,
									message: "Vui lòng nhập thông tin access code!",
								},
							]}
						>
							<Input
								placeholder="Nhập access code"
								showCount
								disabled={!isSupperAdmin}
								maxLength={200}
								onBlur={(e) =>
									form.setFieldValue("accessCode", e.target.value.trim())
								}
							/>
						</Form.Item>
						<Form.Item
							label="Hash key"
							name="hashKey"
							rules={[
								{
									required: true,
									message: "Vui lòng nhập thông tin hash key!",
								},
							]}
						>
							<Input
								placeholder="Nhập hash key"
								disabled={!isSupperAdmin}
								showCount
								maxLength={200}
								onBlur={(e) =>
									form.setFieldValue("hashKey", e.target.value.trim())
								}
							/>
						</Form.Item>
						<Form.Item
							name={"timeAllowedOrder"}
							label={"Thời gian đặt suất ăn trước bữa ăn"}
							rules={[
								{
									required: true,
									message: "Vui lòng chọn thời gian đặt suất ăn trước bữa ăn!",
								},
								{
									validator: (_, value) =>
										value <= 24
											? Promise.resolve()
											: Promise.reject(
													new Error(
														"Thời gian đặt suất ăn trước bữa ăn không quá 24h"
													)
											  ),
								},
							]}
							className="w-full mt-[25px]"
						>
							<Input
								placeholder="Chọn thời gian đặt suất ăn trước bữa ăn"
								className="w-full"
								maxLength={2}
								onKeyDown={handleKeyDownPreventDifferentNumber}
								onPaste={handlePastePreventDifferentNumber}
							/>
						</Form.Item>
						<Form.Item
							name={"timeAllowedUpdate"}
							label={"Thời gian đổi suất ăn trước bữa ăn"}
							rules={[
								{
									required: true,
									message: "Vui lòng chọn thời gian đổi suất ăn trước bữa ăn!",
								},
								{
									validator: (_, value) =>
										value <= 24
											? Promise.resolve()
											: Promise.reject(
													new Error(
														"Thời gian đổi suất ăn trước bữa ăn không quá 24h"
													)
											  ),
								},
							]}
						>
							<Input
								placeholder="Chọn thời gian đổi suất ăn trước bữa ăn"
								className="w-full"
								maxLength={2}
								onKeyDown={handleKeyDownPreventDifferentNumber}
								onPaste={handlePastePreventDifferentNumber}
							/>
						</Form.Item>
						<Form.Item
							name={"timeAllowedDonate"}
							rules={[
								{
									required: true,
									message: "Vui lòng chọn thời gian tặng suất ăn trước bữa ăn!",
								},
								{
									validator: (_, value) =>
										value <= 24
											? Promise.resolve()
											: Promise.reject(
													new Error(
														"Thời gian tặng suất ăn trước bữa ăn không quá 24h"
													)
											  ),
								},
							]}
							label={"Thời gian tặng suất ăn trước bữa ăn"}
						>
							<Input
								placeholder="Chọn thời gian tặng suất ăn trước bữa ăn"
								className="w-full"
								maxLength={2}
								onKeyDown={handleKeyDownPreventDifferentNumber}
								onPaste={handlePastePreventDifferentNumber}
							/>
						</Form.Item>
						<Form.Item
							name={"timeAllowedCancel"}
							rules={[
								{
									required: true,
									message: "Vui lòng chọn thời gian huỷ suất ăn trước bữa ăn!",
								},
								{
									validator: (_, value) =>
										value <= 24
											? Promise.resolve()
											: Promise.reject(
													new Error(
														"Thời gian huỷ suất ăn trước bữa ăn không quá 24h"
													)
											  ),
								},
							]}
							label={"Thời gian huỷ suất ăn trước bữa ăn"}
						>
							<Input
								placeholder="Chọn thời gian huỷ suất ăn trước bữa ăn"
								className="w-full"
								maxLength={2}
								onKeyDown={handleKeyDownPreventDifferentNumber}
								onPaste={handlePastePreventDifferentNumber}
							/>
						</Form.Item>
						<Form.Item
							name={"notificationPhoneNumber"}
							rules={[
								{
									required: true,
									message: "Vui lòng nhập số điện thoại nhận tổng số suất ăn!",
								},
							]}
							label={"Số điện thoại nhận tổng số suất ăn"}
						>
							<Input
								placeholder="Nhập số điện thoại nhận tổng số suất ăn"
								className="w-full"
								showCount
								maxLength={200}
								onKeyDown={(e) => {
									const allowedKeys = [
										"Backspace",
										"Delete",
										"ArrowLeft",
										"ArrowRight",
										"Tab",
										",",
									];
									const { selectionStart, value } = e.currentTarget;

									if (
										(e.ctrlKey || e.metaKey) &&
										(e.key === "a" ||
											e.key === "A" ||
											e.key === "c" ||
											e.key === "C" ||
											e.key === "v" ||
											e.key === "V")
									) {
										return;
									}

									if (e.key === " ") {
										if (
											selectionStart === 0 ||
											(selectionStart !== null &&
												value[selectionStart - 1] !== ",") ||
											(selectionStart !== null && value[selectionStart] === " ")
										) {
											e.preventDefault();
										}
									} else if (e.key === ",") {
										if (
											selectionStart === 0 ||
											(selectionStart !== null &&
												value[selectionStart - 1] === ",")
										) {
											e.preventDefault();
										}
									} else if (
										!/[0-9]/.test(e.key) &&
										!allowedKeys.includes(e.key)
									) {
										e.preventDefault();
									}
								}}
								onPaste={(e) => {
									let paste = e.clipboardData.getData("text");

									paste = paste.replace(/, +/g, ", ");
									if (!/^([0-9]+(, [0-9]+)*)?$/.test(paste)) {
										e.preventDefault();
									} else {
										e.preventDefault();
										const input = e.currentTarget;
										const { selectionStart, selectionEnd, value } = input;
										const newValue =
											value.slice(0, selectionStart!) +
											paste +
											value.slice(selectionEnd!);
										input.value = newValue;
										const event = new Event("input", { bubbles: true });
										input.dispatchEvent(event);
									}
								}}
							/>
						</Form.Item>
					</div>
				</div>
			</Form>
			{contextHolder}
		</div>
	);
};

export default EditKitchen;
